/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * bundle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import.
 */
import { modules } from "./module/modules";
import smoothscroll from "smoothscroll-polyfill";

/**
 * Run.
 */
modules();
smoothscroll.polyfill();

/**
 * Clear console.
 */
// console.clear();